
import React from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.div`
    color: ${props => props.theme.colors.text};
    text-align: left;
`;

export function Header ( props )
{
	return (
        <HeaderContainer>
			<span>EpochTool</span>
        </HeaderContainer>
	);
}

/*
<pre>
&nbsp;&nbsp;&nbsp;___  ____   ___     __  __ __      ______   ___    ___   _     <br/>
&nbsp;&nbsp;/  _]|    \ /   \   /  ]|  |  |    |      | /   \  /   \ | |    <br/>
&nbsp;/  [_ |  o  )     | /  / |  |  |    |      ||     ||     || |    <br/>
|    _]|   _/|  O  |/  /  |  _  |    |_|  |_||  O  ||  O  || |___ <br/>
|   [_ |  |  |     /   \_ |  |  |      |  |  |     ||     ||     |<br/>
|     ||  |  |     \     ||  |  |      |  |  |     ||     ||     |<br/>
|_____||__|   \___/ \____||__|__|      |__|   \___/  \___/ |_____|<br/>
</pre>

*/
